import {
  DeleteOutlined,
  EditOutlined,
  PlayCircleOutlined,
} from "@ant-design/icons";
import { Badge, Button, Popconfirm, Space, Table, Tooltip } from "antd";

export function VideoList({
  data = [],
  loading,
  filter,
  total,
  onFilterChange,
  onEdit,
  onDelete,
}) {
  const columns = [
    {
      title: <strong>STT</strong>,
      dataIndex: "key",
      key: "key",
      width: 60,
      align: "center",
      fixed: "left",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: <strong>Thumbnail</strong>,
      dataIndex: "thumbnail",
      key: "thumbnail",
      width: 150,
      align: "center",
      fixed: "left",
      render: (thumbnail, record) =>
        thumbnail ? (
          <img
            src={thumbnail}
            alt={record.title}
            style={{
              width: 120,
              height: 68,
              objectFit: "cover",
              borderRadius: 6,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          />
        ) : (
          <div
            style={{
              width: 120,
              height: 68,
              backgroundColor: "#f0f0f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#999",
              borderRadius: 6,
              fontSize: 12,
            }}
          >
            Không có thumbnail
          </div>
        ),
    },
    {
      title: <strong>Tiêu đề</strong>,
      dataIndex: "title",
      key: "title",
      fixed: "left",
      width: 300,
      render: (title) => (
        <Tooltip title={title}>
          <strong>{title}</strong>
        </Tooltip>
      ),
    },
    {
      title: <strong>Video ID</strong>,
      dataIndex: "videoId",
      key: "videoId",
      width: 150,
      render: (videoId) => (
        <Tooltip title={videoId}>
          <code>{videoId}</code>
        </Tooltip>
      ),
    },
    {
      title: <strong>URL YouTube</strong>,
      dataIndex: "url",
      key: "url",
      width: 200,
      render: (url) => (
        <Tooltip title={url}>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1890ff" }}
          >
            {url.length > 30 ? `${url.substring(0, 30)}...` : url}
          </a>
        </Tooltip>
      ),
    },
    {
      title: <strong>Trạng thái</strong>,
      dataIndex: "isActive",
      key: "isActive",
      align: "center",
      render: (isActive) => (
        <Badge
          status={isActive ? "success" : "error"}
          text={isActive ? "Hoạt động" : "Ngừng hoạt động"}
        />
      ),
      width: 120,
    },
    {
      title: <strong>Chức năng</strong>,
      key: "action",
      width: 120,
      fixed: "right",
      align: "center",
      render: (_, record) => (
        <Space size="small">
          <Tooltip title="Xem video">
            <Button
              type="text"
              size="small"
              icon={<PlayCircleOutlined />}
              onClick={() => window.open(record.url, "_blank")}
              style={{ color: "#52c41a" }}
            />
          </Tooltip>
          <Tooltip title="Sửa">
            <Button
              type="text"
              size="small"
              icon={<EditOutlined />}
              onClick={() => onEdit(record)}
              style={{ color: "#1890ff" }}
            />
          </Tooltip>
          <Popconfirm
            title="Bạn có chắc muốn xóa?"
            onConfirm={() => onDelete(record._id)}
            okText="Có"
            cancelText="Không"
          >
            <Tooltip title="Xóa">
              <Button
                type="text"
                danger
                size="small"
                icon={<DeleteOutlined />}
              />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Table
      scroll={{ x: 1000 }}
      columns={columns}
      dataSource={
        data.length
          ? data.map((item, idx) => ({
              ...item,
              ...(filter && {
                key: (filter.page - 1) * filter.limit + idx + 1,
              }),
            }))
          : []
      }
      loading={loading}
      rowKey="_id"
      pagination={{
        current: filter.page,
        pageSize: filter.limit,
        total,
        showSizeChanger: true,
        onChange: (page, pageSize) =>
          onFilterChange({ ...filter, page, limit: pageSize }),
      }}
      size="middle"
      bordered
      rowClassName={() => "hover-row"}
    />
  );
}
